import {
  Box,
  IconButton,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from '@chakra-ui/react';
import { PanelWrapper } from '../../components/shared/PanelWrapper/PannelWrapper';
import { FilterContainer } from '../../components/shared/Filter/FilterContainer';
import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import { useQuery } from '../../utils/hooks/useQuery';
import { ManagerViewModel } from '../../types/models';
import { useState } from 'react';
import { ManagerModal } from '../../components/Managers/ManagerModal';
import { DeleteConfirmationPopover } from '../../components/shared/Popover/DeleteConfirmationPopover';
import { toast } from 'react-toastify';
import { useApiCall } from '../../utils/hooks/useApiCall';
import { deleteManager } from '../../services/managersServices';

const columns = [
  { label: 'ID', key: 'id' },
  { label: 'Nome Pessoa', key: 'people.name' },
  { label: 'Entidade', key: 'entity' },
  { label: 'Registro Entidade', key: 'entityNumber' },
  { label: 'Ações', key: 'actions' },
];

export const ManagersPage = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [managerData, setManager] = useState<ManagerViewModel | undefined>();
  const [managerLoading, setManagerLoading] = useState(false);
  const { data: managers, refetch } = useQuery<ManagerViewModel[]>('/managers');
  const api = useApiCall();

  const handleClose = () => {
    setManager(undefined);
    onClose();
  };

  const handleOpenEditModal = (usr: ManagerViewModel) => {
    setManager(usr);
    onOpen();
  };

  const handleDelete = async (managerId: number) => {
    try {
      setManagerLoading(true);
      await deleteManager(managerId, api);
      refetch();
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setManagerLoading(false);
    }
  };

  return (
    <>
      <ManagerModal
        manager={managerData}
        refetch={refetch}
        isOpen={isOpen}
        onClose={handleClose}
      />
      <PanelWrapper title="Coordenadores">
        <FilterContainer onOpenModal={onOpen} />
        <Box className="rounded-lg shadow p-4 pt-10 mt-5">
          <Table>
            <Thead>
              <Tr>
                {columns.map((column) => (
                  <Th key={column.key}>{column.label}</Th>
                ))}
              </Tr>
            </Thead>
            <Tbody>
              {managers?.map((row) => (
                <Tr
                  key={row.id}
                  className="hover:bg-gray-50 hover:cursor-pointer"
                >
                  <Td>{row.id}</Td>
                  <Td>{row.people?.name}</Td>
                  <Td>{row.entity}</Td>
                  <Td>{row.entityNumber}</Td>
                  <Td>
                    <div className="w-full flex justify-around">
                      <DeleteConfirmationPopover
                        loading={managerLoading}
                        onConfirm={() => handleDelete(row.id)}
                      >
                        <IconButton
                          colorScheme="red"
                          aria-label="Excluir"
                          icon={<DeleteIcon color="white" />}
                        />
                      </DeleteConfirmationPopover>{' '}
                      <IconButton
                        onClick={() => handleOpenEditModal(row)}
                        colorScheme="blue"
                        aria-label="Editar"
                        icon={<EditIcon color="white" />}
                      />
                    </div>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      </PanelWrapper>
    </>
  );
};
